import Request from "../../services/Request";
import ResponseChecker from "../../services/ResponseChecker";
import NotiMessage from "../../services/NotiMessage";

const currentYear = new Date().getFullYear();
const years = [];
for (let y = currentYear; y >= 2020; y--) {
    years.push({ text: y });
}
years.push({ value: null, text: " " });

const notiMessage = new NotiMessage("success");

// URL //
const eachUrl = "basic_data/getEach?";
const allUrl = "basic_data/get?";
const storeUrl = "basic_data/store";
const updateUrl = "basic_data/update?";
const deleteUrl = "basic_data/delete?";

const state = {
    basicData: [],
    eachBasicData: {},
    years,
    months: [
        { value: 1, text: "Jan" },
        { value: 2, text: "Feb" },
        { value: 3, text: "Mar" },
        { value: 4, text: "Apr" },
        { value: 5, text: "May" },
        { value: 6, text: "June" },
        { value: 7, text: "July" },
        { value: 8, text: "Aug" },
        { value: 9, text: "Sept" },
        { value: 10, text: "Oct" },
        { value: 11, text: "Nov" },
        { value: 12, text: "Dec" },
        { value: null, text: " " },
    ],

    export_months: [
        { value: 1, text: "Jan" },
        { value: 2, text: "Feb" },
        { value: 3, text: "Mar" },
        { value: 4, text: "Apr" },
        { value: 5, text: "May" },
        { value: 6, text: "June" },
        { value: 7, text: "July" },
        { value: 8, text: "Aug" },
        { value: 9, text: "Sept" },
        { value: 10, text: "Oct" },
        { value: 11, text: "Nov" },
        { value: 12, text: "Dec" },
        { value: 13, text: "Quarter 1" },
        { value: 14, text: "Quarter 2" },
        { value: 15, text: "Quarter 3" },
        { value: 16, text: "Quarter 4" },
        { value: 17, text: "S 1" },
        { value: 18, text: "S 2" },
        { value: 19, text: "Annual" },
        { value: null, text: " " },
    ],

    s_export_months:[
        { value: 1, text: "Jan" },
        { value: 2, text: "Feb" },
        { value: 3, text: "Mar" },
        { value: 4, text: "Apr" },
        { value: 5, text: "May" },
        { value: 6, text: "June" },
        { value: 7, text: "July" },
        { value: 8, text: "Aug" },
        { value: 9, text: "Sept" },
        { value: 10, text: "Oct" },
        { value: 11, text: "Nov" },
        { value: 12, text: "Dec" },
        
        { value: 13, text: "S 1" },
        { value: 14, text: "S 2" },
        { value: 15, text: "Annual" },
        
        { value: null, text: " " },
    ],

    supportTypes: [
        { id: 1, name: "P1.Medication" },
        { id: 2, name: "P2.Hearing aids" },
        { id: 3, name: "P3.Palliative care" },
        { id: 4, name: "P4.Hospitalization" },
        { id: 5, name: "P5.Housing support" },
        { id: 6, name: "P6.Pre-enrolment support" },
        { id: 7, name: "P7.Nutritional support" },
        { id: 8, name: "P8.Follow-up & referral TA" },
        { id: 9, name: "P9.Poor patient support" },
    ],
};
const getters = {};
const mutations = {
    SET_BASIC_DATA(state, payload) {
        state.basicData = payload.data.data;
    },
    SET_EACH_BASIC_DATA(state, payload) {
        state.eachBasicData = payload.data.data;
    },
    ADD_BASIC_DATA(state, payload) {
        state.basicData.push(payload.data.data);
    },
    REMOVE_BASIC_DATA(state, payload) {
        const basicData = state.basicData.filter((item) => item.id != payload.id);
        state.basicData = [...basicData];
    },
};

const actions = {
    async asyncget({ commit }, type) {
        const response = await Request.get_data(allUrl, { type: type });
        const responseChecker = new ResponseChecker(response);
        responseChecker.checkResponse();
        if (responseChecker.isResponseStatusSuccess())
            commit("SET_BASIC_DATA", response);
    },
    async getEach({ commit }, id, type) {
        let params = { type: type, column: "id", value: id };
        const response = await Request.get_data(eachUrl, params);
        const responseChecker = new ResponseChecker(response);
        responseChecker.checkResponse();
        if (responseChecker.isResponseStatusSuccess())
            commit("SET_EACH_BASIC_DATA", response);
    },
    async create({ commit }, payload) {
        const response = await Request.post_data(storeUrl, payload);
        const responseChecker = new ResponseChecker(response);
        responseChecker.checkResponse();
        if (responseChecker.isResponseStatusSuccess()) {
            commit("ADD_BASIC_DATA", response);
            notiMessage.displayNotiMsg("Saved Success");
            return true;
        }
        return false;
    },
    async update({ dispatch }, payload) {
        const response = await Request.post_data(updateUrl, { id: payload.id });
        const responseChecker = new ResponseChecker(response);
        responseChecker.checkResponse();
        if (responseChecker.isResponseStatusSuccess()) {
            notiMessage.displayNotiMsg("Updated Success");
            dispatch("get", payload.type);
            return true;
        }
        return false;
    },
    async delete({ commit }, payload) {
        const response = await Request.post_data(deleteUrl, payload);
        const responseChecker = new ResponseChecker(response);
        responseChecker.checkResponse();
        if (responseChecker.isResponseStatusSuccess()) {
            commit("REMOVE_BASIC_DATA", response.data.data);
            notiMessage.displayNotiMsg("Deleted Success");
            return true;
        }
        return false;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};